import { ChangePasswordModule } from './main/pages/authentication/change-password/change-password.module';
import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { TranslateModule } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeBr from '@angular/common/locales/pt';
import 'hammerjs';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';

import { fuseConfig } from './fuse-config';

import { AppComponent } from './app.component';
import { AppStoreModule } from './store/store.module';
import { LayoutModule } from './layout/layout.module';
import { AuthGuard } from './main/pages/authentication/auth.guard';
import { Config } from './_helper/config';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from './shared/shared.module';
import { LocalModule } from './local/local.module';

export function configProviderFactory(provider: Config) { return () => provider.load(); }
registerLocaleData(localeBr, 'pt');
const appRoutes: Routes = [
    {
        path        : 'perfil',
        canActivate: [AuthGuard],
        loadChildren: () => import('./main/pages/pages.module').then(m => m.PagesModule)
    },
    {
        path        : 'apps',
        canActivate: [AuthGuard],
        loadChildren: () => import('./apps/apps.module').then(m => m.AppsModule)
    },
    {
        path        : 'pages',
        loadChildren: () => import('./main/pages/pages.module').then(m => m.PagesModule)
    },
    {
        path      : '**',
        redirectTo: 'apps/resumo'
    }
];

@NgModule({
    declarations: [
        AppComponent,
    ],
    providers:[
        AuthGuard,
        Config,
        { provide: LOCALE_ID, useValue: 'pt' },
        { provide: APP_INITIALIZER, useFactory: configProviderFactory, deps: [Config], multi: true },
        
    ],
    imports     : [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes),
        TranslateModule.forRoot(),
        LocalModule,

    
        // Material moment date module
        MatMomentDateModule,

        // Material
        SharedModule,
        // Fuse modules
        FuseModule.forRoot(fuseConfig),
      //  NgxMaskModule.forRoot(),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,
        AppStoreModule,
        ToastrModule.forRoot({ positionClass: 'toast-top-full-width'}),
        ChangePasswordModule
    ],
    bootstrap   : [
        AppComponent
    ]
})
export class AppModule
{
    
}
